import { createReducer } from "../../../../helpers/reducer";
import { PARTNERS_LOADED } from "../actions/partners";
import { LOCATION_CHANGE } from "react-router-redux/reducer";

export default createReducer(null, {
  [LOCATION_CHANGE]: (state, action) => null,
  [PARTNERS_LOADED]: (state, action) => action.payload.partners,
});



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/reducers/ui-partners-reducer.js